import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysRemaining'
})
export class DaysRemainingPipe implements PipeTransform {
  transform(value: string | Date): number {
    if (!value) return 0;

    const today = new Date();
    const target = new Date(value);

    if (target <= today) return 0;

    const diffMs = target.getTime() - today.getTime();
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }
}
